import { BASE_URL, CALCULATOR_BASE_URL, CRM_API_URL } from "./baseURL";
import { get, post } from "./api";

export const getCalculatorData = (payload) => {
  return new Promise(async (resolve, reject) => {
    const { universityMind, plan, inflation, university } = payload;
    try {
      const res = await get(
        `${CALCULATOR_BASE_URL}university?Country=${university}&PlanTerm=${plan}&InflationRate=${inflation}&University=${universityMind}`
      );
      resolve(res.data);
    } catch (err) {
      reject(err);
    }
  });
};

export const getSocialLinks = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await get(
        `${BASE_URL}/api/utils?populate[0]=social_icon.social_img`
      );
      // Strapi v5: response is now res.data directly (no .attributes nesting)
      resolve(res?.data);
    } catch (err) {
      reject(err);
    }
  });
};

export const getPageNotFound = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await get(
        `${BASE_URL}/api/not-found?populate[0]=notfound&populate[1]=background.img&populate[2]=seo_meta`
      );
      resolve(res.data);
    } catch (err) {
      reject(err);
    }
  });
};

export const getHeaderRoutes = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await get(
        `${BASE_URL}/api/plan-types?populate[content]=true&populate[plans][populate]=content&populate[header_menu_icon][populate]=img&sort=order`
      );
      resolve(res?.data);
    } catch (err) {
      reject(err);
    }
  });
};

export const getSpeakToAdvisor = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await get(
        `${BASE_URL}/api/speak-to-advisor?
populate[title]=true
&populate[name]=true
&populate[email]=true
&populate[number]=true
&populate[submitbutton]=true
&populate[thanks][populate][icon]=true
&populate[thanksbutton]=true
`
      );
      resolve(res.data);
    } catch (err) {
      reject(err);
    }
  });
};

export const setCRMLead = (payload) => {
  const fullName = payload.name ? payload.name.trim() : "";
  const nameParts = fullName.split(" ");

  const FirstName = nameParts.length > 0 ? nameParts[0] : "";
  const LastName = nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";
  const copPayload = {
    FirstName: FirstName,
    LastName: LastName,
    CPR: payload.CPR ? payload.CPR : "",
    PhoneNumber: payload.mobile ? payload.mobile : "",
    subject: "Plate 6 Motor Campaign",
    Product: "LIFE",
    Email: payload.email ? payload.email : "",
    customerType: 1,
    status: 1,
    productType: "Motor",
    stage: "",
    lead_id: "",
    Quote: "",
    channel: "online.solidarity",
    LOBProduct: "Education/saving plans",
  };
  return new Promise(async (resolve, reject) => {
    try {
      const res = await post(CRM_API_URL, copPayload);
      resolve(res.data);
    } catch (err) {
      reject(err);
    }
  });
};

export const getMenuDropdowns = (payload) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await get(
        `${BASE_URL}/api/parent-menus?sort=order` +
        `&populate[label]=true` +
        `&populate[menu_groups][populate][menu_group][populate][icon][populate][img]=true` +
        `&populate[menu_groups][populate][menu_group][populate][menu][populate][icon]=true`
      );
      resolve(res.data);
    } catch (err) {
      reject(err);
    }
  });
};